export default "__VITE_ASSET__B0nXxFv3__"